import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {isWidthUp} from '@material-ui/core/withWidth';
import {Fab, Grid, Typography, Card, CardContent, CardMedia, withWidth} from '@material-ui/core';
import {ArrowForward} from "@material-ui/icons";
import {Fade} from 'react-reveal';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  textContainer: {
    padding: theme.spacing.unit * 12,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing.unit * 6
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 4
    }
  },
  description: {
    color: theme.palette.text.secondary
  },
  tryNowButton: {
    fontSize: theme.spacing.unit * 1.5,
    marginTop: theme.spacing.unit * 2,
    fontWeight: 'bold',
  },
  tagLine: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    color: theme.palette.secondary.dark
  },
  cardsContainer: {
    paddingTop: theme.spacing.unit * 4,
    paddingBottom: theme.spacing.unit * 4
  },
  card: {
    boxShadow: '0px 5px 12px -6px rgba(156,156,156,0.2),0px 18px 24px 2px rgba(156,156,156,0.2),0px 6px 32px 4px rgba(156,156,156,0.2)',
    // minHeight: 350,
    // maxHeight: 350,
    height: '100%',
    backgroundColor: theme.palette.text.primary,
    padding: theme.spacing.unit * 4,
    margin: theme.spacing.unit * 2,
    transition: 'all .3s ease-in-out',
    '&:hover': {
      transform: 'scale(1.1)'
    }
  },
  media: {
    height: 60,
    marginBottom: theme.spacing.unit * 2,
    maxWidth: 60,
  }
});

const WhyCryptX = withStyles(styles)(({classes, width}) => (
  <div className={classes.root}>
    <Grid container direction="column" justify="center"
          className={classes.textContainer}>
      <Fade bottom duration={1500} cascade={true} distance="100px">
        <Grid item>
          <Typography variant="caption" gutterBottom className={classes.tagLine}>
            Trading | Payments | Investments | Commerce
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant={isWidthUp('md', width, false) ? 'h3' : 'h4'} color="inherit" gutterBottom>
            Why <span style={{fontWeight: 'bold'}}> CryptX Financial?</span>
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="caption" color="inherit" className={classes.description}>
            Diversify, Consolidate, Invest or Liquify - CryptX Financial provides a decentralized ecosystem
          </Typography>
          <Typography variant="caption" color="inherit" className={classes.description}>
            that minimizes transaction fees and middlemen.
          </Typography>
          <Typography gutterBottom variant="caption" color="inherit" className={classes.description}>
            You can seamlessly customize, control and grow your assets on CryptX Financial.
          </Typography>
        </Grid>
        <Grid item className={classes.cardsContainer}>
          <Grid container direction="row" justify="center" alignItems="stretch" wrap="wrap" spacing={24}>
            {/* Card 1 */}
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Card className={classes.card}>
                <CardContent>
                  <CardMedia
                    className={classes.media}
                    image="/images/icons/why-cryptx/decentralization.svg"
                    title="Icon"
                  />
                  <Typography gutterBottom variant="body1" color="inherit">
                    Decentralization
                  </Typography>
                  <Typography variant="caption" className={classes.description}>
                    Our blockchain is called Hyperledger ANVIL. It is a multipurpose distributed transaction validation
                    and storage ledger that uses both Web and Mobile Devices as nodes for duplicity and cryptography.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            {/* Card 2 */}
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Card className={classes.card}>
                <CardContent>
                  <CardMedia
                    className={classes.media}
                    image="/images/icons/why-cryptx/fiat-crypto-pairs.svg"
                    title="Icon"
                  />
                  <Typography gutterBottom variant="body1" color="inherit">
                    Fiat - Crypto Pairing
                  </Typography>
                  <Typography variant="caption" className={classes.description}>
                    CryptX Instant is a feature that let’s you swap Fiat to Crypto or Crypto to Fiat instantly with no
                    waiting time. We strive to provide a highly liquid marketplace.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            {/* Card 3 */}
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Card className={classes.card}>
                <CardContent>
                  <CardMedia
                    className={classes.media}
                    image="/images/icons/why-cryptx/military-grade-security.svg"
                    title="Icon"
                  />
                  <Typography gutterBottom variant="body1" color="inherit">
                    Military Grade Security
                  </Typography>
                  <Typography variant="caption" className={classes.description}>
                    CryptX Financial uses Military Grade Hot + Cold Wallet interaction algorithms along with a
                    blockchain
                    based storage system to immutably store your assets negating any security risks.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            {/* Card 4 */}
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Card className={classes.card}>
                <CardContent>
                  <CardMedia
                    className={classes.media}
                    image="/images/icons/why-cryptx/global-scalability.svg"
                    title="Icon"
                  />
                  <Typography gutterBottom variant="body1" color="inherit">
                    Global Scalability
                  </Typography>
                  <Typography variant="caption" className={classes.description}>
                    CryptX Financial is a one of a kind ecosystem that can be used from any part of the world. You using
                    trading, payments, investments and commerce at any time, any place. More FIAT markets will be added
                    soon.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            {/* Card 5 */}
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Card className={classes.card}>
                <CardContent>
                  <CardMedia
                    className={classes.media}
                    image="/images/icons/why-cryptx/financially-regulated.svg"
                    title="Icon"
                  />
                  <Typography gutterBottom variant="body1" color="inherit">
                    Financially Regulated
                  </Typography>
                  <Typography variant="caption" className={classes.description}>
                    CryptX Financial is regulated by the Government of the Grand Duchy of Luxembourg using extensive
                    licensing and auditory requirements. You can view the certificate here.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            {/* Card 6 */}
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Card className={classes.card}>
                <CardContent>
                  <CardMedia
                    className={classes.media}
                    image="/images/icons/why-cryptx/24-7-accessibility.svg"
                    title="Icon"
                  />
                  <Typography gutterBottom variant="body1" color="inherit">
                    24/7 Accessibility
                  </Typography>
                  <Typography variant="caption" className={classes.description}>
                    Our system is built to serve the demands of the millennial commerce. We assure 99.6% uptime (Per
                    Annum) to all our customers, on any timezone or on any day.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs className={classes.tryNowButtonContainer}>
          <Grid container justify="center">
            <Grid item>
              <Fab variant="extended" size="large" color="primary" className={classes.tryNowButton}>
                Try Now
                <ArrowForward fontSize="small"/>
              </Fab>
            </Grid>
          </Grid>
        </Grid>
      </Fade>
    </Grid>
  </div>
));

export default withWidth()(WhyCryptX);
